import React, { useEffect, useRef, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, IconButton, FormControl, InputLabel, Select,
    MenuItem, Switch, Box, Typography,
    Chip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from '@mui/icons-material/Delete';
import api_service from "../../network/api_callbacks";

const AddQuestionDialog = ({ editableQuestion, setEditableQuestion, handleAddDialogOnClose, open, onClose, onSubmit }) => {

    const question_type = [
        { "id": "01", "title": "Trivia" },
        { "id": "02", "title": "Predictive" }
    ]

    const anchor_type = [
        { "id": "01", "title": "Show" },
        { "id": "02", "title": "Trivia Sub Category" }
    ]

    const anchor_list = [
        {
            "id": "sh_07",
            "text": "The Joe Rogan Experience",
        },
        {
            "id": "sh_08",
            "text": "Serial",
        },
        {
            "id": "sh_09",
            "text": "This American Life",
        }
    ]

    const answer = {
        "id": "",
        "text": ""
    }

    const [questionTypeDD, setQuestionTypeDD] = useState(null);
    const [anchorTypeDD, setAnchorTypeDD] = useState(null);
    const [anchorListDD, setAnchorListDD] = useState(null);

    const fileInputRef = useRef(null);
    const [question, setQuestion] = useState("");
    const [type, setType] = useState("");
    const [anchorType, setAnchorType] = useState("");
    const [anchorList, setAnchorList] = useState("");
    const [multimedia, setMultimedia] = useState("");
    const [answers, setAnswers] = useState([]);
    const [correctAnswer, setCorrectAnswer] = useState("");
    const [status, setStatus] = useState("");
    const [isValidBT,setIsValidBT] = useState(false);


    // console.log("type : ",type);
    // console.log("anchorType : ",anchorType);
    // console.log("anchorList : ",anchorList);
    // console.log("question : ",question);
    // console.log("answers : ",answers?.every(item => item?.text && item?.text?.trim() !== ""));
    // console.log("correctAnswer : ",correctAnswer?.text?.trim());

    const isValidNew = type &&
                        type?.title?.trim() !== '' &&
                        anchorType && 
                        anchorType?.title?.trim() !== '' &&
                        anchorList && 
                        anchorList?.text?.trim() !== '' &&
                        question?.trim() !== '' &&
                        answers?.length>=2 &&
                        answers?.every(item => item?.text && item?.text?.trim() !== "") &&
                        correctAnswer && 
                        correctAnswer?.text?.trim() !== ''

    useEffect(() => {
        const isAnswersValesEmpty = answers.every(ans => !ans.id && !ans.text);
        const isArrayEmpty = answers.length === 0;
        console.log("isAnswersEmpty : ", isAnswersValesEmpty) //true
        console.log("isArrayEmpty : ", isArrayEmpty) //false
        if (editableQuestion) {
            console.log(answers?.length)
            if (isAnswersValesEmpty) {
                console.log("run -2")
                setQuestionTypeDD(question_type);
                if (!anchorTypeDD) {
                    setAnchorTypeDD(anchor_type);
                }
                if (!anchorListDD) {
                    setAnchorListDD(anchor_list);
                }

                //console.log("editableQuestion", editableQuestion)
                const type_api = editableQuestion?.type;
                const anchorType_api = editableQuestion?.anchorType;
                const anchor_api = editableQuestion?.anchor;
                const question_api = editableQuestion?.questionText;
                const answers_api = editableQuestion?.options;
                const correct_answer_api = editableQuestion?.correctOptionIds?.[0];
                const multimedia_api = editableQuestion?.multimedia;
                const status_api = editableQuestion?.status;

                const _type = question_type?.find((item) => item?.title?.toLowerCase() === type_api?.toLowerCase());
                const _anchorType = anchorTypeDD?.find((item) => item?.title?.toLowerCase() === anchorType_api?.title?.toLowerCase());
                const _anchorList = anchorListDD?.find((item) => item?.text?.toLowerCase() === anchor_api?.text?.toLowerCase());

                //console.log("_anchorType : ", _anchorType);
                //console.log("_anchorList : ", _anchorList);

                setStatus(status_api);
                setType(_type);
                setAnchorType(_anchorType);
                setAnchorList(_anchorList);
                setQuestion(question_api);
                setMultimedia(multimedia_api);
                setAnswers(answers_api);
            }
        }
        else {
            reInitialize();
        }
        return (() => {
            //setAnswers([answer, answer]);
        })
    }, [editableQuestion])

    useEffect(() => {
        if (!answer?.id) {
            const correct_answer_api = editableQuestion?.correctOptionIds?.[0];
            const _correct_Answer = answers?.find((item) => item?.text?.toLowerCase() === correct_answer_api?.text?.toLowerCase());
            if (!correctAnswer && type?.title?.toLowerCase() === 'trivia') {
                console.log("_type : trivia")
                setCorrectAnswer(_correct_Answer);
            }
        }
    }, [answers])

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            const mimeType = file.type;
            var type = "unknown";
            if (mimeType.startsWith("image/")) {
                type = "image";
            } else if (mimeType.startsWith("video/")) {
                type = "video";
            } else if (mimeType.startsWith("audio/")) {
                type = "audio";
            }
            setMultimedia({type: type, details: { url: url, file: file }});
        }
    };

    const handleAddAnswer = () => {
        if (answers.length < 8) {
            setAnswers([...answers, {}]);
        }
    };

    const handleChangeAnswer = (value, index) => {
        console.log(value, index)
        const updated = [...answers];
        updated[index] = { "id": "", "text": value };
        setAnswers(updated);
    };

    const handleSubmit = (mode) => {
        if (mode === "delete") {
            const data = {
                question: editableQuestion,
                mode: mode
            }
            onSubmit(data);
        }
        else {
            if (isValidNew) {
                const item = {
                    "id": editableQuestion?.id,
                    "status": status,
                    "type": type?.title,
                    "anchorType": anchorType,
                    "anchor": anchorList,
                    "questionText": question,
                    "multimedia": multimedia,
                    "options": answers,
                    "correctOptionIds": [
                        correctAnswer
                    ]
                }
                const data = {
                    question: item,
                    mode: mode
                }
                onSubmit(data);
            }
        }
    };

    const reInitialize = () => {
        setQuestionTypeDD(question_type);
        setAnchorTypeDD(anchor_type);
        setAnchorListDD(anchor_list);
        setQuestion("");
        setType("");
        setAnchorType("");
        setAnchorList("");
        setMultimedia("");
        setCorrectAnswer("");
        setStatus("active");
        setAnswers([answer, answer]);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                ADD QUESTION
                {editableQuestion && <IconButton onClick={() => { handleSubmit("delete") }} sx={{ position: "absolute", right: 50, top: 8 }}>
                    <DeleteIcon />
                </IconButton>}
                <IconButton onClick={() => { handleAddDialogOnClose() }}
                    sx={{ position: "absolute", right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers sx={{ backgroundColor: "#f9f9f9" }}>
                <FormControl fullWidth margin="normal">
                    <InputLabel sx={CssStyles.inputLabelStyle_sx}>Type</InputLabel>
                    <Select value={type}
                        onChange={(e) => {
                            console.log("type : ", e.target.value)
                            setType(e.target.value)
                        }}
                        label="Type"
                        sx={CssStyles.formFiledStyle_sx}>
                        {questionTypeDD?.map((item, idx) => (
                            <MenuItem key={idx} value={item} sx={CssStyles.menuItemStyle_sx}>{item?.title}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="normal">
                    <InputLabel sx={CssStyles.inputLabelStyle_sx}>Anchor Type</InputLabel>
                    <Select value={anchorType}
                        onChange={(e) => {
                            console.log("anchorType : ", e.target.value)
                            setAnchorType(e.target.value)
                        }}
                        label="Anchor Type"
                        sx={CssStyles.formFiledStyle_sx}>
                        {anchorTypeDD?.map((item, idx) => (
                            <MenuItem key={idx} value={item} sx={CssStyles.menuItemStyle_sx}>{item?.title}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="normal">
                    <InputLabel sx={CssStyles.inputLabelStyle_sx}>Anchor List</InputLabel>
                    <Select value={anchorList} onChange={(e) => {
                        console.log("anchorList : ", e.target.value)
                        setAnchorList(e.target.value)
                    }}
                        label="Anchor List" sx={CssStyles.formFiledStyle_sx}>
                        {anchorListDD?.map((item, idx) => (
                            <MenuItem key={idx} value={item} sx={CssStyles.menuItemStyle_sx}>{item?.text}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Box display="flex" flexDirection="column" justifyContent="space-between" width="100%" alignItems="center" gap={1} mt={2}>
                    {/* <Typography mt={1} mb={1} sx={{ alignSelf: "flex-start" }}>Question</Typography> */}
                    <Box display="flex" alignItems="stretch" gap={1} mt={0} width="100%">
                        <TextField
                            fullWidth
                            label="Question"
                            multiline
                            rows={4}
                            value={question}
                            onChange={(e) => setQuestion(e.target.value)}
                            sx={CssStyles.formMultiLineTextField_sx}
                        />
                        {/* <Button variant="contained" color="secondary" sx={{ height: "100%" }}>Upload</Button> */}
                        <>
                            <input
                                type="file"
                                accept="video/*,image/*,audio/*"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                            />
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ height: "100%" }}
                                onClick={handleButtonClick}
                            >
                                {multimedia ? "Change" : "Upload"}
                            </Button>
                        </>
                    </Box>
                </Box>

                <Box display="flex" justifyContent="space-between" width="100%" alignItems="center" gap={1} mt={2}>
                    <Typography mt={1} mb={1}>Answers</Typography>
                    {answers.length < 8 && (
                        <IconButton onClick={handleAddAnswer} sx={{ mt: 0 }}>
                            <AddIcon />
                        </IconButton>
                    )}
                </Box>

                {answers.map((ans, idx) => (
                    <TextField
                        key={idx}
                        fullWidth
                        margin="dense"
                        value={ans.text}
                        placeholder={`Answer ${idx + 1}`}
                        sx={CssStyles.formMultiLineTextField_sx}
                        onChange={(e) => handleChangeAnswer(e.target.value, idx)}
                    />
                ))}

                <FormControl fullWidth margin="normal">
                    <InputLabel sx={CssStyles.inputLabelStyle_sx}>Correct Answer</InputLabel>
                    {(correctAnswer) ? (<Select
                        value={correctAnswer}
                        onChange={(e) => {
                            console.log("Correct Answer select : ", e.target.value)
                            setCorrectAnswer(e.target.value)
                        }}
                        label="Correct Answer"
                        sx={CssStyles.formFiledStyle_sx}
                    >
                        {answers?.map((ans, idx) => (
                            <MenuItem key={idx} value={ans} sx={CssStyles.menuItemStyle_sx}>{ans?.text}</MenuItem>
                        ))}
                    </Select>) :
                        (answers?.length > 0) ?
                            (<Select
                                value={correctAnswer}
                                onChange={(e) => {
                                    console.log("Correct Answer select : ", e.target.value)
                                    setCorrectAnswer(e.target.value)
                                }}
                                label="Correct Answer"
                                sx={CssStyles.formFiledStyle_sx}
                            >
                                {answers?.map((ans, idx) => (
                                    <MenuItem key={idx} value={ans} sx={CssStyles.menuItemStyle_sx}>{ans?.text}</MenuItem>
                                ))}
                            </Select>)
                            :
                            (<Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                Add at least one answer to select a correct answer.
                            </Typography>)}
                </FormControl>

                {/* <Box display="flex" alignItems="center" justifyContent="space-between" mt={2}>
                    <Typography>Status</Typography>
                    <Chip
                        label={status === 'active' ? "active" : "deactivated"}
                        color={status === 'active' ? 'success' : 'error'}
                        onClick={() => setStatus(status === 'active' ? 'deactivated' : 'active')}
                        clickable={false}
                        sx={{
                            color: "white", // Ensure the text is visible
                        }}
                    />
                </Box> */}
            </DialogContent>

            <DialogActions sx={{ px: 3, p: 2 }}>
                <Button
                    fullWidth
                    variant="contained"
                    sx={{ height: 50, backgroundColor: "#a855f7", color: 'white', fontSize: 16 }}
                    onClick={() => {
                        handleSubmit(editableQuestion ? "update" : "new")
                    }}
                    disabled={!isValidNew}
                >
                    {editableQuestion ? "Update Question" : "Add Question"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export const CssStyles = {
    inputLabelStyle_sx: {
        color: 'text.secondary',
        '&.Mui-focused': {
            color: 'text.secondary', // Change color on focus
        },
    },
    menuItemStyle_sx: {
        '&.Mui-selected': {
            color: 'text.primary',
        },
    },
    formFiledStyle_sx: {
        '& .MuiSelect-select': {
            color: 'text.primary', // Text color
            borderWidth: '1px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'text.primary', // Default outline
            borderWidth: '1px',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'text.primary', // Outline when focused
            borderWidth: '1px',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'text.primary', // Outline on hover
            borderWidth: '1px',
        },
        '& label.Mui-focused': {
            color: 'text.primary',
        },
    },
    formMultiLineTextField_sx: {
        '& .MuiOutlinedInput-root': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.primary', // Your desired color
                borderWidth: '1px',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.primary',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'text.primary',
            },
        },
        '& .MuiInputBase-root': {
            resize: 'vertical', // Allow vertical resizing
            overflow: 'auto',   // Show scrollbars if needed
            color: 'text.primary',
            borderWidth: '1px',
        },
        '& label.Mui-focused': {
            color: 'text.primary',
        },
    }
}

export default AddQuestionDialog;